module.exports = __webpack_public_path__ + "static/media/12583693_1044190468957126_564574497_n.f8654d67.jpg";